module.exports = __webpack_public_path__ + "static/img/logo6.342834b8.png";